<template>
  <v-layout class="gallery" column>
    <v-flex>
      <v-layout class="gallery-preview">
        <v-img
          v-if="currentImageUrls"
          :src="currentImageUrls.large"
          :lazy-src="currentImageUrls.lazy"
          max-height="40vh"
          min-height="40vh"
        />
        <recipe-image-placeholder v-else />
      </v-layout>
    </v-flex>
    <v-flex class="gallery-thumbnails secondary">
      <v-layout>
        <div
          :style="thumbnailStyle"
          class="gallery-thumbnail add-button"
          v-if="addButton"
        >
          <v-icon color="secondary">fas fa-plus</v-icon>
        </div>
        <div
          class="gallery-thumbnail"
          :class="{ active: index === currentImageIndex }"
          v-for="(number, index) in imageSlotsCount"
          :key="number"
          :style="thumbnailStyle"
          @click="changeImage(index)"
        >
          <v-img :src="imagesUrls[index].lazy" height="100%" />
        </div>
      </v-layout>
    </v-flex>
  </v-layout>
</template>

<script>
import {
  IMAGE_SIZE_LARGE,
  IMAGE_SIZE_LAZY,
  imageUrl
} from "@/utils/ImageUtils";
import RecipeImagePlaceholder from "@/components/RecipeImagePlaceholder";

export default {
  name: "ImageGallery",
  components: { RecipeImagePlaceholder },
  props: {
    images: {
      type: Array,
      default: () => []
    },
    addButton: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      currentImageIndex: 0
    };
  },
  computed: {
    imagesUrls() {
      return this.images.map(image => ({
        lazy: imageUrl(image, IMAGE_SIZE_LAZY),
        large: imageUrl(image, IMAGE_SIZE_LARGE)
      }));
    },
    currentImageUrls() {
      return this.currentImageIndex < this.images.length
        ? this.imagesUrls[this.currentImageIndex]
        : null;
    },
    imageSlotsCount() {
      let slots = this.thumbnailsMaxCount;
      if (this.addButton) {
        slots--; // slot for add button
      }
      if (this.images.length > slots) {
        slots--; // slot for show all
      } else {
        slots = this.images.length;
      }
      return slots;
    },
    thumbnailsMaxCount() {
      switch (this.$vuetify.breakpoint.name) {
        default:
        case "xs":
          return 5;
        case "sm":
          return 7;
        case "md":
          return 9;
        case "lg":
          return 12;
        case "xl":
          return 16;
      }
    },
    thumbnailStyle() {
      return {
        width: `${100 / this.thumbnailsMaxCount}%`
      };
    }
  },
  methods: {
    changeImage(index) {
      this.currentImageIndex = index;
    }
  }
};
</script>

<style scoped lang="stylus">
.gallery-thumbnail {
  height: auto;

  &:hover {
    cursor: pointer;
  }

  &.add-button {
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(0,0,0,0.75);
  }
}
</style>
